import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveLine } from '@nivo/line';
import { get } from 'lodash';
import { colors } from './styles';

export const ChartLine = props => (
  <ResponsiveLine
    margin={{
      top: 20,
      right: 50,
      bottom: 150,
      left: 130
    }}
    xScale={{
      type: 'point'
    }}
    yScale={{
      type: 'linear',
      stacked: true,
      min: 'auto',
      max: 'auto'
    }}
    axisTop={null}
    axisRight={null}
    axisBottom={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: -35
    }}
    axisLeft={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: props.axisLeftLegend,
      legendPosition: 'middle',
      legendOffset: -80,
      format: props.format
    }}
    colors={colors}
    lineWidth={5}
    dotSize={10}
    dotColor="#ffffff"
    dotBorderWidth={2}
    dotBorderColor="#8ed43d"
    dotLabel="y"
    dotLabelYOffset={-12}
    animate={false}
    maxValue="auto"
    minValue="auto"
    tooltip={({ data }) => {
      const { x, y } = get(data, [0, 'data'], {});
      return `${x}: ${props.format(y)}`;
    }}
    {...props}
  />
);

ChartLine.propTypes = {
  axisLeftLegend: PropTypes.string,
  format: PropTypes.func.isRequired
};

ChartLine.defaultProps = {
  axisLeftLegend: null
};

export default ChartLine;
